import { Row } from 'antd';
import { Button, PermissionWrapper, Spacer } from 'components';
import { ClosableWrapperRef } from 'components/ClosableWrapper/ClosableWrapper';
import { ConditionalWrapper } from 'components/ShowWrapper/ConditionalWrapper';
import { text } from 'constants/texts';
import { useChildrenRef } from 'hooks';
import { ProgramDetailsConfirmModal } from 'pages/ProgramDetails/common/ProgramDetailsConfirmModal';
import { SurveyDetailMoreAction } from 'pages/ProgramDetails/programTabComponents/Content/ContentTabComponents/Surveys/components/SurveyDetailMoreAction';
import { TabActionsProps } from 'pages/ProgramDetails/tabsConfig/types';
import { showCancelEditedToast } from 'pages/ProgramDetails/utils';
import { Survey } from 'types/surveys';

export const SurveyDetailsTabActions = ({
  program,
  isEditMode,
  isLoading,
  onClose,
  onSave,
  onEdit,
  survey,
}: TabActionsProps & { survey: Survey }) => {
  const [confirmModalRef, setConfirmModalRef] = useChildrenRef<ClosableWrapperRef>();

  if (!program) return null;

  const onModalConfirm = () => {
    showCancelEditedToast();
    confirmModalRef?.close();
    onClose();
  };

  return (
    <Row>
      <PermissionWrapper permissionsRequired={['surveys.edit']}>
        <Button onClick={isEditMode ? onSave : onEdit} loading={isLoading}>
          {text[isEditMode ? 'Save' : 'Edit']}
        </Button>
      </PermissionWrapper>
      <Spacer width={16} />
      <ConditionalWrapper condition={isEditMode}>
        <Button type='ghost' onClick={confirmModalRef?.open}>
          {text['Cancel']}
        </Button>
      </ConditionalWrapper>
      <ConditionalWrapper condition={!isEditMode}>
        <SurveyDetailMoreAction survey={survey} />
      </ConditionalWrapper>
      <ProgramDetailsConfirmModal
        type='Cancel'
        modalRef={setConfirmModalRef}
        cancelHandler={confirmModalRef?.close}
        confirmHandler={onModalConfirm}
      />
    </Row>
  );
};
